<template>
  <div>
    <MyBreadcrumb
      :breadcrumb-list="[
        {text:'工作台',to:'/'},
        {text:'应用详情',to:''}
      ]"
    ></MyBreadcrumb>

    <!-- 数据加载中显示骨架屏 -->
    <skeleton v-if="detailLoading"></skeleton>
    <div
      v-else
      class="page-content"
    >
      <!-- 顶部 -->
      <div class="product-top">
        <img
          class="product-img"
          :src="detail.productImage"
        >
        <div class="product-top-right">
          <div class="info-item">
            <span class="info-item-label">产品名称：</span>
            <span class="info-item-value"> {{ detail.productName }}</span>
          </div>
          <!-- <div class="info-item">
            <span class="info-item-label">订购规格：</span>
            <span class="info-item-value">
              <span>{{ detail.skuName }}</span>
              <span v-if="detail.shopNum">/{{ detail.shopNum }}个店铺</span>
            </span>
          </div> -->
          <!-- <div
            v-if="detail.freeShopNum || detail.buyShopNum"
            class="info-item"
          >
            <span class="info-item-label">店铺数量：</span>
            <span class="info-item-value">
              <span v-if="detail.freeShopNum">赠送{{ detail.freeShopNum }}个 </span>
              <span v-if="detail.buyShopNum">购买{{ detail.buyShopNum }}个</span>

            </span>
          </div> -->
          <!-- <div class="info-item">
            <span class="info-item-label">订购金额：</span>
            <span class="info-item-value">  ￥{{ detail.payFee }}</span>
          </div> -->
          <div class="info-item">
            <span class="info-item-label">主体信息：</span>
            <span class="info-item-value"> {{ detail.corpName }}</span>
          </div>
          <div class="info-item">
            <span class="info-item-label">有效期：</span>
            <span class="info-item-value">  {{ detail.serviceEnd }}</span>
          </div>
          <!-- <div class="info-item">
            <span class="info-item-label">订购时间：</span>
            <span class="info-item-value"> {{ detail.serviceStart }}</span>
          </div>
          <div class="info-item">
            <span class="info-item-label">系统账号：</span>
            <span class="info-item-value"> {{ detail.accountNo }}</span>
          </div>
          <div class="info-item">
            <span class="info-item-label">订购人：</span>
            <span class="info-item-value"> {{ detail.phone }}</span>
          </div> -->
          <div class="order-bottom">
            <button
              class="btn btn1"
              :disabled="!detail.canRenew"
              @click="goRenew"
            >
              续费
            </button>
            <!-- <button
              class="btn btn2"
              :disabled="!detail.canUpgrade"
              @click="goUpgrade"
            >
              升级
            </button> -->
            <!-- <button
              class="btn btn3"
              :disabled="!detail.canAddShop"
              @click="goBugShop"
            >
              增加店铺
            </button> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import skeleton from './components/skeleton';
export default {
  components: {
    skeleton,
  },
  data(){
    return {
      detailLoading: true,
      detail: {
      },
    };
  },
  created(){
    // 获取详情
    this.getDetail();
  },
  methods: {
    // 去续费
    goRenew(){
      const {productCode} = this.$route.query;
      const {buyRecordId,accountNo} = this.detail;
      this.$router.push({
        path: '/standardProduct/order/index',
        query: {
          productCode,
          buyRecordId,
          accountNo,
        },
      });
    },
    // 升级
    goUpgrade(){
      const {productCode} = this.$route.query;
      this.$router.push({
        path: '/app/order/index',
        query: {
          productCode,
          // corpCode,
          // corpName,
          skuId: this.selectSkuItem.skuId,
        },
      });
    },
    // 购买店铺
    goBugShop() {
      const {corpCode} = this.$store.state.user.userInfo;
      // if (!corpCode){
      //   return;
      // }
      const {productCode,buyerId} = this.$route.query;
      const url = '/paycenter-charge/api/worktable/ordered/detail';
      const params = {
        productCode,
        buyerId,
        corpCode,
      };
      this.detailLoading = true;
      this.$http.get(url,params).then(res => {
        if (res.success) {
          this.detailLoading = false;
          this.detail = res.data;
        } else {
          this.$Message.warning(res.message || '获取详情失败');
        }
      });
    },
    // 获取详情
    getDetail() {
      const {corpCode} = this.$store.state.user.userInfo;
      // if (!corpCode){
      //   return;
      // }
      const {productCode,buyerId} = this.$route.query;
      const url = '/paycenter-charge/api/worktable/ordered/detail';
      const params = {
        productCode,
        buyerId,
        corpCode,
      };
      this.detailLoading = true;
      this.$http.get(url,params).then(res => {
        if (res.success) {
          this.detailLoading = false;
          this.detail = res.data;
        } else {
          this.$Message.warning(res.message || '获取详情失败');
        }
      });
    },

  },
};
</script>
<style lang="less" scoped>
.product-top {
  position: relative;
  box-sizing: border-box;
  overflow: hidden;
  background-color: #fff;
  margin-bottom: 10px;
  padding: 30px;
  display: flex;
  // align-items: center;
  .product-img {
    // float: left;
    width: 304px;
    height: 214px;
    flex-shrink: 0;
  }
  .product-top-right {
    // float: left;
    padding-left: 20px;
  }
  .order-bottom {
    margin-top: 30px;
    .btn {
      padding: 2px 20px;
      cursor: pointer;
      margin-right: 30px;
      border: 1px solid #4772fc;
      color: #4772fc;
      background: transparent;
      &:disabled {
        background-color: #ccc;
        cursor: not-allowed;
        border: 1px solid #ccc;
        color: #fff;
      }
    }
    .btn1 {
      background: #4772fc;
      color: #fff;
    }
  }
  .info-item {
    margin-bottom: 20px;
    .info-item-label {
      color: #999;
      display: inline-block;
      width: 76px;
    }
  }
}
</style>
